import {
  productSupplierList,
  productSupplierCreate,
  productSupplierUpdate,
  productSupplierDestroy,
} from '@/services/shop/productSuppliers.service'

export default {
  namespaced: true,
  state: {
    suppliers: { data: [], meta: { pagination: { total: 0 } } },
    status: 'init',
  },
  getters: {
    getSuppliers: s => s.suppliers,
    getStatus: s => s.status,
  },
  mutations: {
    SET_SUPPLIERS(state, value) { state.suppliers = value },
    SET_STATUS(state, value) { state.status = value },
  },
  actions: {
    async fetchSuppliers({ commit }, params) {
      commit('SET_STATUS', 'pending')
      try {
        const { data } = await productSupplierList(params)
        commit('SET_SUPPLIERS', data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_STATUS', 'init')
      }
    },

    async saveSupplier({ dispatch }, { form, page, perPage }) {
      const action = form.id ? productSupplierUpdate(form.id, form) : productSupplierCreate(form)
      await action
      dispatch('fetchSuppliers', { page, per_page: perPage })
    },

    async removeSupplier({ dispatch }, { id, page, perPage }) {
      await productSupplierDestroy(id)
      dispatch('fetchSuppliers', { page, per_page: perPage })
    },
  },
}
